import { LocationDto } from "../dtos";
import { RulesLogic } from "json-logic-js";
import isString from "lodash/isString";
import isObject from "lodash/isObject";

export class Location {
  id = -1;
  name: string;
  address: string;
  tags: string[];
  paymentRules: RulesLogic | null = null;
  no_prepayment_hours: number;
  email_used_too_often_hours_limit: number;
  sections_sequence: string[];
  packages_title: string;
  packages_description: string;
  activities_title: string;
  activities_description: string;

  constructor(dto: LocationDto) {
    this.id = dto.id;
    this.name = dto.name;
    this.address = dto.address;
    this.tags = dto.activities;
    if (isString(dto.booking_engine_payment_rules)) {
      this.paymentRules = JSON.parse(dto.booking_engine_payment_rules);
    }
    if (isObject(dto.booking_engine_payment_rules)) {
      this.paymentRules = dto.booking_engine_payment_rules;
    }
    this.no_prepayment_hours = dto.no_prepayment_hours;
    this.email_used_too_often_hours_limit =
      dto.email_used_too_often_hours_limit;
    this.sections_sequence = dto.sections_sequence;
    this.packages_title = dto.packages_title;
    this.packages_description = dto.packages_description;
    this.activities_title = dto.activities_title;
    this.activities_description = dto.activities_description;
  }
}
